<template>
  <div class="news-index-page--template page-template">
    <div class="bg clouds-top-right"></div>
    <div class="container-fluid relative">
      <section class="mw7 relative z-1 center pv4 pv5-ns">
          <div class="bg ski-dancer"></div>
          <div class="tc">
            <h1 class="page-title pt4">{{ page.title }}</h1>
          </div>
      </section>
      <div class="absolute z-0 mw4 mw5-ns topography topography-top-left-wrap">
          <simple-svg
              :filepath="'/assets/images/svg/gdz18-topography.svg'"
              :id="'topography-top-left'"
          ></simple-svg>
      </div>
    </div>
    <div class="container-fluid relative">
      <section class="mw7 relative z-1 center mv2 mv3-ns" v-for="(post, index) in posts" v-if="index < 1">
        <img class="db relative center content-image" :src="post['Featured Image']" v-if="post['Featured Image']">
        <img class="db relative center content-image" src="/uploads/gdz18-news-hero.jpg" v-else>
        <h2 class="is-interstate-black ttu tc lh-title pointer cream-bg mh--1">
          <router-link class="db f3 f2-ns pa2 pa3-ns no-underline pointer is-red" :to="post.url">
            <span class="text">
              {{ post.title }}
            </span>
          </router-link>
        </h2>
        <div class="db relative center pv3 pa4-ns bg-light-blue-ns is-purple">
          <p class="">
            {{ post.Excerpt | truncate(100) }}
          </p>
          <router-link class="ttu link is-red pointer" :to="post.url">+ View More</router-link>
        </div>
      </section>
      <div class="absolute z-0 topography topography-bottom-right-wrap">
        <simple-svg
            :filepath="'/assets/images/svg/gdz18-topography.svg'"
            :id="'topography-bottom-right'"
        ></simple-svg>
      </div>
    </div>
    <div class="container-fluid relative">
      <section class="mw8 relative z-1 center mv4 mv5-ns">
        <div class="row mb4">
          <div class="col-xs-12 col-sm-6 ph2-ns mv2 mv3-ns" v-for="(post, index) in posts" v-if="index > 0">
              <img class="db relative center news-secondary-image content-image" :src="post['Featured Image']" v-if="post['Featured Image']">
              <img class="db relative center news-secondary-image content-image" src="/uploads/gdz18-news-thumb3.jpg" v-else>
              <h2 class="content-title mv0 ttu tc cream-bg mh1">
                <router-link class="db f4 f3-ns pa2 pv3-ns ph1-ns no-underline pointer is-red" :to="post.url">
                  <span class="text">
                    {{ post.title }}
                  </span>
                </router-link>
              </h2>
              <div class="db relative center w-80 pv3 pa4-ns bg-light-blue-ns f5 is-purple">
                <p class="" >
                  {{ post.Excerpt | truncate(100) }}
                </p>
                <router-link class="ttu link is-red pointer" :to="post.url">+ View More</router-link>
              </div>
          </div>
        </div>
        <div class="bg plus-signs"></div>
      </section>
    </div>
  </div>
</template>

<script>
import Marked from 'marked';
export default {
  //template: '#news-index-page-template',
  props: ['id','pageName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk} | ` + this.$site_name : this.$site_name;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      isLoading: false,
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('news-index.md');
      return pageData[0];
    },
    posts: function () {
      var postsData = this.$store.getters.filterDataByCollection('posts');
      return postsData;
    },
    post: function () {
      var postsData = this.$store.getters.filterDataByCollection('posts');
      return postsData[index].previous.next;
    }
  },
  methods : {
    //
  }
}
</script>